<template>
    <v-dialog lazy v-if="displayGalleryDialog" fullscreen v-model="displayGalleryDialog">
        <div class="zoomer-gallery-container">
            <div class="zoom-buttons">
                <v-btn icon @click="$refs.zoomerGallery.zoomIn()">
                    <v-icon>add</v-icon>
                </v-btn>
                <v-btn icon @click="$refs.zoomerGallery.zoomOut()">
                    <v-icon>remove</v-icon>
                </v-btn>
            </div>

            <v-btn icon class="close-button" @click="displayGalleryDialog = false">
                <v-icon>close</v-icon>
            </v-btn>

            <v-zoomer-gallery
                class="zoomer-gallery"
                :list="imagesList"
                v-model="index"
                pivot="image-center"
                ref="zoomerGallery"
                backgroundColor="#fff"
            ></v-zoomer-gallery>

            <v-btn icon class="nav-left" @click="prevSlide()">
                <v-icon>arrow_back_ios</v-icon>
            </v-btn>

            <v-btn icon class="nav-right" @click="nextSlide()">
                <v-icon>arrow_forward_ios</v-icon>
            </v-btn>

            <carousel
                class="nav-carousel"
                :scrollPerPage="false"
                :navigationEnabled="true"
                :paginationEnabled="false"
                :perPage="navSlidesPerPage"
                ref="navCarousel"
            >
                <slide
                    v-for="(productImage, i) in galleryElements"
                    :key="i"
                    class="nav-carousel-slide"
                    :class="{'active': i === index}"
                >
                    <img :src="productImage.small" @click="index = i">
                </slide>
            </carousel>
        </div>
    </v-dialog>
</template>

<script>
    import Vue from 'vue';
    import VueZoomer from 'vue-zoomer';
    import {Carousel, Slide} from 'vue-carousel';

    Vue.use(VueZoomer);

    export default {
        props: {
            value: Boolean,
            galleryElements: {},
            currentSlide: {
                type: Number,
                default: 0,
            },
        },
        components: {
            Carousel,
            Slide,
        },
        data() {
            return {
                showZoomer: false,
                navSlidesPerPage: 1,
            };
        },
        mounted() {
            window.addEventListener('resize', this.onResize, {passive: true});
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResize, {passive: true});
        },
        computed: {
            index: {
                get() {
                    return this.currentSlide;
                },
                set(value) {
                    this.$emit('slideChange', value);
                },
            },
            displayGalleryDialog: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                },
            },
            imagesList() {
                let result = [];

                for (let productImage of this.galleryElements) {
                    result.push(productImage.extra);
                }

                return result;
            },
        },
        methods: {
            nextSlide() {
                if (this.index === this.imagesList.length - 1) {
                    this.index = 0;
                } else {
                    this.index++;
                }
            },
            prevSlide() {
                if (this.index === 0) {
                    this.index = this.imagesList.length - 1;
                } else {
                    this.index--;
                }
            },
            onResize() {
                if (this.$refs.navCarousel) {
                    //100 - is the width of navCarousel image set below in the css
                    this.navSlidesPerPage = parseInt(this.$refs.navCarousel.$el.offsetWidth / 100);
                }
            },
        },
        watch: {
            value(value) {
                if (value) {
                    this.$nextTick(() => {
                        this.onResize();
                    });
                }
            },
        },
    };
</script>

<style>
    .zoomer-gallery-container {
        height: 100%;
        position: relative;
        background: white;
    }

    .zoomer-gallery-container .zoomer-gallery {
        width: calc(100% - 80px);
        height: calc(100% - 100px);
        margin: 0 auto;
    }

    .zoomer-gallery-container .nav-left {
        position: absolute;
        top: 50%;
        left: 0;
        z-index: 1;
    }

    .zoomer-gallery-container .nav-right {
        position: absolute;
        top: 50%;
        right: 0;
        z-index: 1;
    }
    .zoomer-gallery-container .nav-left:hover {
        position: absolute;
    }

    .zoomer-gallery-container .nav-right:hover {
        position: absolute;
    }

    .zoomer-gallery-container .zoom-buttons {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
    }

    .zoomer-gallery-container .zoom-buttons button {
        display: block;
    }

    .zoomer-gallery-container .close-button {
        position: absolute;
        top: 5px;
        right: 5px;
        z-index: 1;
    }

    .zoomer-gallery-container .close-button:hover {
        position: absolute;
    }

    .zoomer-gallery-container .nav-carousel {
        height: 100px;
    }

    .zoomer-gallery-container .nav-carousel img {
        height: 100%;
        width: 100%;
        object-fit: contain;
    }

    .zoomer-gallery-container .nav-carousel-slide {
        border: 1px solid white;
    }

    .zoomer-gallery-container .nav-carousel-slide.active {
        border: 1px solid black;
    }

    .zoomer-gallery-container .VueCarousel-navigation-prev {
        left: 27px !important;
    }

    .zoomer-gallery-container .VueCarousel-navigation-next {
        right: 27px !important;
    }

    .zoomer-gallery-container .VueCarousel-inner {
        height: 100px !important;
    }
</style>